// WHO SEES WHATSAPP (Karan, 17/10/2026): "only release for me at this stage …
// as soon as it goes live we can switch it on for everyone."
//
// The pilot list always sees every WhatsApp surface (project Correspondence tab
// and import, Mail's WhatsApp chips/rows/reader/New WhatsApp/settings, Ask
// Track's WhatsApp hits, the Help topic). Everyone else sees Track exactly as
// before (an "Emails" tab) until the switch is on.
//
// THE SWITCH: Mail › Settings › WhatsApp › "WhatsApp for everyone" (Owner only).
// It writes organisations/asp.whatsappRelease.everyone. Read at sign-in, so
// other people get the change on their next reload.
import { orgWhatsappRelease } from './db.js';

export const WHATSAPP_PILOT = ['karan@aspconsulting.co.uk'];

let releasedToAll = false;

export function loadWhatsappRelease() {
  return orgWhatsappRelease()
    .then((r) => { releasedToAll = !!(r && r.everyone); })
    .catch(() => {});
}

/** After the switch is flipped in this tab — no reload needed for the person flipping it. */
export function setReleasedToAll(on) { releasedToAll = !!on; }

export function canWhatsApp(email) {
  return releasedToAll || WHATSAPP_PILOT.includes(String(email || '').toLowerCase());
}
